/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-promise-executor-return */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Card, Grid, Heading, Illustration, MAGNETIC_TOKENS, SearchBox, Spinner, css, utils } from '@appd/uik';
import { useState } from 'react';
import { DateTime } from 'luxon';
import { Spacer } from '../Spacer';
import { MedalCell } from './MedalCell';
import { TeamCell } from './TeamCell';
import { fetchItems } from './fetchItems';

export const MedalTally = () => {
  const [isLoading, setIsLoading] = useState(true);

  const [lastUpdated, setLastUpdated] = useState(NaN);

  const [items, setItems] = useState<typeof MedalTally.SAMPLE_DATA>([]);

  const [search, setSearch] = useState('');

  utils.useEffect.unstrict(() => {
    const { lastUpdated = -Infinity, items = [] } = JSON.parse(MedalTally.CACHE.get() ?? '{}') as {
      lastUpdated?: number;
      items?: typeof MedalTally.SAMPLE_DATA;
    };

    if (Date.now() - lastUpdated < MedalTally.CACHE.MS) {
      setItems(items);

      setLastUpdated(lastUpdated);

      setIsLoading(false);

      return;
    }

    const nextUpdated = +DateTime.now();

    const controller = new AbortController();

    fetchItems(controller)
      .then(items => {
        setItems(items);

        if (items.length) {
          setLastUpdated(nextUpdated);

          MedalTally.CACHE.set(
            JSON.stringify({
              lastUpdated: nextUpdated,
              items,
            }),
          );
        }
      }, console.warn)
      .finally(() => setIsLoading(false));

    return () => controller.abort();
  }, []);

  return (
    <>
      <Heading
        className={{
          color: '#373C42',
          fontFamily: 'Paris2024-Variable',
          marginLeft: MAGNETIC_TOKENS.SPACING[1],
          // Too thick in Chrome
          fontWeight: 450 ?? 550,
          fontSize: 20,
          lineHeight: '34px',
        }}
      >
        Medal Tally
      </Heading>

      <Spacer height={9} />

      <Card className={{ paddingBottom: 4, borderRadius: MAGNETIC_TOKENS.SPACING[3] }}>
        <SearchBox
          placeholder="Search by country name"
          value={search}
          onChange={setSearch}
          className={{
            '> svg': { paddingLeft: 5 },
            '> input': {
              height: 24,
              fontFamily: 'Inter',
              fontSize: 12,
              lineHeight: '18px',
              padding: 0,
            },
            '> button': { minWidth: 24, height: 24, paddingRight: 0, borderRadius: MAGNETIC_TOKENS.SPACING[1] },
            maxWidth: 280,
          }}
        />
        {isLoading && <Spinner size="XLARGE" className={{ justifyContent: 'center', height: 353 }} />}
        {!isLoading && items.length === 0 && (
          <Illustration
            className={{ height: 353 }}
            secondary="Couldn't connect to medals tally"
            icon="Health.InfoMessage"
          />
        )}
        {!isLoading && items.length > 0 && (
          <Grid
            filter={search}
            className={{
              '& .ag-cell': { padding: `${MAGNETIC_TOKENS.SPACING[3]}px !important` },
              height: 353,
            }}
            rowHeight={44}
            showConfigure={false}
            columns={[
              {
                field: 'Team',
                minWidth: 0,
                sortable: true,
                cellRenderer: ({ value }) => <TeamCell country={value} />,
              },
              {
                field: 'Gold',
                width: 70,
                sortable: true,
                cellRenderer: ({ value }) => <MedalCell kind="Gold" count={value} />,
              },
              {
                field: 'Silver',
                width: 70,
                sortable: true,
                cellRenderer: ({ value }) => <MedalCell kind="Silver" count={value} />,
              },
              {
                field: 'Bronze',
                width: 70,
                sortable: true,
                cellRenderer: ({ value }) => <MedalCell kind="Bronze" count={value} />,
              },
              {
                field: 'Total',
                width: 70,
                sortable: true,
                cellRenderer: ({ value }) => <MedalCell kind="Total" count={value} />,
              },
            ]}
            rows={items}
          />
        )}
      </Card>

      {Number.isFinite(lastUpdated) && (
        <>
          <Spacer height={9} />

          <div
            className={css({
              marginLeft: MAGNETIC_TOKENS.SPACING[1],
              font: MAGNETIC_TOKENS.TYPOGRAPHY.P4_DEFAULT,
              color: MAGNETIC_TOKENS.COLORS.DEFAULT_TEXT_WEAK,
              textAlign: 'right',
            })}
          >
            Last updated on {DateTime.fromMillis(lastUpdated).toFormat('h:mm a, d MMMM yyyy')}
          </div>
        </>
      )}
    </>
  );
};

MedalTally.CACHE = {
  KEY: 'paris2024.LiveNewsDrawer.MedalTally',
  MS: 1 * 60 * 60 * 1000 /* 1 hours */,
  clear: () => localStorage.removeItem(MedalTally.CACHE.KEY),
  get: () => localStorage.getItem(MedalTally.CACHE.KEY),
  set: (value: string) => localStorage.setItem(MedalTally.CACHE.KEY, value),
};

MedalTally.SAMPLE_DATA = [
  { Team: 'France', Gold: 10, Silver: 20, Bronze: 7, Total: 37 },
  { Team: 'Argentina', Gold: 30, Silver: 11, Bronze: 1, Total: 42 },
  { Team: 'Armenia', Gold: 1, Silver: 2, Bronze: null, Total: 3 },
  { Team: 'Australia', Gold: 5, Silver: 22, Bronze: 23, Total: 60 },
  { Team: 'Austria', Gold: 5, Silver: 2, Bronze: 2, Total: 9 },
  { Team: 'Azerbaijan', Gold: 1, Silver: null, Bronze: null, Total: 1 },
  { Team: 'Bahamas', Gold: 4, Silver: 1, Bronze: 4, Total: 9 },
];
